import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1gipetfw: FaireBrandEntity = {
  token: "b_1gipetfw",
  type: "brand",
  name: "Splendid Iris",
  avatarUrl:
    "https://cdn.faire.com/fastly/d90eeec0499af42f63ac84c637405ad36102aeb94ab50bb14322c0e90f25e7e7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/bc55ba19deab9fb6b3d6dfa8503613faee42a483c7ca7d05bf9a37e9f32241a1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d90eeec0499af42f63ac84c637405ad36102aeb94ab50bb14322c0e90f25e7e7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bc55ba19deab9fb6b3d6dfa8503613faee42a483c7ca7d05bf9a37e9f32241a1.jpeg",
  location: "Westlake Village, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 349,
  isTopShop: true,
  isInsider: true,
  description:
    "Splendid Iris was started in 2010 by Joanne and Jamie, a mother-daughter team, with the mission to create beautiful, affordable jewelry for women of all ages. Named after Joanne’s mom, who had an impeccable eye for style, Splendid Iris offers timeless pieces to elevate any look.\n\nJoanne and Jamie envisioned a brand that blended their individual styles. Jamie, a busy mom of four, enjoys simple and delicate accents to fit her casual style while Joanne prefers bolder, dressier pieces to take her from day to night.  Together, this mother-daughter pair set out to create a cohesive line they would both want to wear, while keeping all women in mind. So whether you like classic designs, trend-setting layers, or something in between, there's something here for you.   \n\nSplendid Iris' Core Jewelry line is 18k Gold or Rhodium Plated Brass. They also offer a small Water-Resistant line that is 18k Gold PVD Plated or Polished Stainless Steel.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T08:29:02.615Z",
    importedBy: "entity-db-cli",
  },
};
